module.exports = __webpack_public_path__ + "assets/img/ab138ab.ab138abc.jpg";